import { string, object } from "yup";

export const loginValidationSchema = (t: any) => object().shape({
    email: string().email(t("validationMessages.fieldIsNotValid",{field:t("fields.emailAddress")}))
        .required(t("validationMessages.fieldIsRequired",{field:t("fields.emailAddress")})),
    password: string().required(t("validationMessages.fieldIsRequired",{field:t("fields.password")}))
})